<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">My Profile</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">My Profile</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <!-- profile box -->
      <student-header></student-header>
      <!-- profile box -->
      <div class="row">
        <!-- sidebar -->
        <student-sidebar></student-sidebar>
        <!-- sidebar -->
        <div class="col-lg-9">
          <div class="page-title d-flex align-items-center justify-content-between">
            <h5 class="fw-bold">My Profile</h5>
            <!-- <a href="#" class="edit-profile-icon"><i class="isax isax-edit-2"></i></a> -->
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="fs-18 pb-3 border-bottom mb-3">Basic Information</h5>
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <h6>Nickname: </h6>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="mb-3">
                    <span>{{ authStore.currentUser.nickname }}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <h6>Company: </h6>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="mb-3">
                    <span>{{ authStore.currentUser.company }}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <h6>Email</h6>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="mb-3">
                    <span>{{ authStore.currentUser.email }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <footer-two></footer-two> -->
</template>
<script>
import PrincipalHeader from "@/views/pages/dashboard/principal/components/Principal-header.vue";
import PrincipalSidebar from "@/views/pages/dashboard/principal/components/Principal-sidebar.vue";
import { useAuthStore } from "@/stores/auth-store";

export default {
  components: {
    PrincipalHeader,
    PrincipalSidebar,
  },
  data() {
    return {};
  },
  setup() {
    const authStore = useAuthStore();
    return {
      authStore,
    };
  },
};
</script>
